import { render, staticRenderFns } from "./MaterialMapperWidget.vue?vue&type=template&id=b19639b0&scoped=true&"
import script from "./MaterialMapperWidget.vue?vue&type=script&lang=js&"
export * from "./MaterialMapperWidget.vue?vue&type=script&lang=js&"
import style0 from "./MaterialMapperWidget.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MaterialMapperWidget.vue?vue&type=style&index=1&id=b19639b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19639b0",
  null
  
)

export default component.exports